// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KQO1","colMin":"styles_colMin__50dEU"};